import * as Sentry from '@sentry/react'
import { AxiosError, AxiosResponse } from 'axios'

import { ReporterEvent } from '@/types'

// Check the response shape; Event.tsx decides which statuses it can render.
export const hasReporterEventFields = (
  data: unknown,
): data is ReporterEvent => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return false
  }
  const event = data as Record<string, unknown>
  return (
    typeof event.id === 'string' &&
    event.id.length > 0 &&
    typeof event.name === 'string' &&
    typeof event.reporter_status === 'string'
  )
}

export const parseReporterEventResponse = (
  response: AxiosResponse<unknown>,
): ReporterEvent => {
  const { data, status } = response
  if (status >= 200 && status < 300 && hasReporterEventFields(data)) {
    return data
  }

  const bodyType =
    data === null ? 'null' : Array.isArray(data) ? 'array' : typeof data
  const reporterStatus =
    data && typeof data === 'object' && 'reporter_status' in data
      ? (data as Record<string, unknown>).reporter_status
      : undefined
  Sentry.captureMessage('Invalid reporter event response', {
    level: 'warning',
    tags: { response_validation: 'reporter_event' },
    extra: {
      http_status: status,
      body_type: bodyType,
      reason: status === 0 ? 'zero_status' : 'invalid_event_response',
      reporter_status:
        typeof reporterStatus === 'string'
          ? reporterStatus.slice(0, 80)
          : typeof reporterStatus,
    },
  })
  // Throw before React Query can replace the last valid cached event.
  throw new AxiosError(
    'Invalid reporter event response',
    AxiosError.ERR_BAD_RESPONSE,
  )
}
